export const OPEN_REPORTS_NAVIGATION_EVENT = 'open-reports-navigation'
export const CLOSE_REPORTS_NAVIGATION_EVENT = 'close-reports-navigation'
export const REPORTS_NAVIGATION_HOVER_EVENT = 'reports-navigation-hover'

export const isReportsNavigationUrl = (url) => {
  if (typeof url !== 'string') return false

  const pathname = url.split(/[?#]/)[0].replace(/\/+$/, '')

  return pathname === '/reports' || pathname.startsWith('/reports/')
}

export const openReportsNavigation = () => {
  window.dispatchEvent(new Event(OPEN_REPORTS_NAVIGATION_EVENT))
}

export const closeReportsNavigation = () => {
  window.dispatchEvent(new Event(CLOSE_REPORTS_NAVIGATION_EVENT))
}

export const setReportsNavigationHovered = (isHovered) => {
  window.dispatchEvent(
    new CustomEvent(REPORTS_NAVIGATION_HOVER_EVENT, {
      detail: { isHovered: Boolean(isHovered) },
    }),
  )
}
